/**
 * created by yxy
 * 采访任务 添加任务
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../base/BaseComponent";
import {Button, message, Modal} from 'antd';
import NomalInput from '../components/btn/NomalInput'
import {uuid} from "../../../utils";
import {Scrollbars} from "react-custom-scrollbars";
import $ from "jquery";
let that;

const config = [
    [{
        componentType: "NomalInput", // UI类型
        value: "this.state.information.title", // 值所在位置
        label: "任务名称", // 标签名
        labelCode: "title", // 标签key
        placeholder: "请输入任务名称", // 空输入框提示
        maxLength: 1, // 最大长度
        message: "请输入任务名称", // 校验提示
        required: true, // 是否必填
        disabled: false, // 是否禁用
        id: "information_titlePic", // 标签id
        size: "default", // 标签大小
        regularCheck: null, // 校验正则
    }
// ,{
//         componentType: "SelectInput", // UI类型
//         value: "this.state.information.titlePic", // 值所在位置
//         label: "所属项目", // 标签名
//         labelCode: "titlePic", // 标签key
//         placeholder: "请上传标题图", // 空输入框提示
//         maxLength: 1, // 最大长度
//         message: "请上传标题图", // 校验提示
//         required: false, // 是否必填发
//         disabled: false, // 是否禁用
//         id: "information_titlePic", // 标签id
//         size: "default", // 标签大小
//         regularCheck: null, // 校验正则
//     }
    ],
    [{
        componentType: "TaskTime", // UI类型
        value: "this.state.information.startTime,this.state.information.endTime", // 值所在位置
        label: "任务时间", // 标签名
        labelCode: "titlePic", // 标签key
        maxLength: 1, // 最大长度
        message: "请选择任务时间", // 校验提示
        placeholder: ['开始时间', '结束时间'],
        required: false, // 是否必填
        disabled: false, // 是否禁用
        id: "information_titlePic", // 标签id
        size: "default", // 标签大小
        regularCheck: null, // 校验正则
    }, {
        componentType: "NomalInput", // UI类型
        value: "this.state.information.place", // 值所在位置
        label: "任务地点", // 标签名
        labelCode: "place", // 标签key
        placeholder: "请输入任务地点", // 空输入框提示
        maxLength: 1, // 最大长度
        message: "请输入任务地点", // 校验提示
        required: false, // 是否必填
        disabled: false, // 是否禁用
        id: "information_titlePic", // 标签id
        size: "default", // 标签大小
        regularCheck: null, // 校验正则
    }],
    [{
        componentType: "DraftReplyTime", // UI类型
        value: "this.state.information.replyTime", // 值所在位置
        label: "回稿时间", // 标签名
        labelCode: "replyTime", // 标签key
        maxLength: 1, // 最大长度
        message: "请选择回稿时间", // 校验提示
        placeholder: '请选择时间',
        required: false, // 是否必填
        disabled: false, // 是否禁用
        id: "information_titlePic", // 标签id
        size: "default", // 标签大小
        regularCheck: null, // 校验正则
    }, {
        componentType: "SelectInput", // UI类型
        value: "this.state.information.sponsor", // 值所在位置
        label: "主办单位", // 标签名
        labelCode: "sponsor", // 标签key
        placeholder: "请输入主办单位", // 空输入框提示
        maxLength: 1, // 最大长度
        message: "请输入主办单位", // 校验提示
        required: false, // 是否必填
        disabled: false, // 是否禁用
        id: "information_titlePic", // 标签id
        size: "default", // 标签大小
        regularCheck: null, // 校验正则
    }],
    [{
        componentType: "NomalInput", // UI类型
        value: "this.state.information.contacts", // 值所在位置
        label: "联系人", // 标签名
        labelCode: "contacts", // 标签key
        placeholder: "请输入联系人", // 空输入框提示
        maxLength: 1, // 最大长度
        message: "请输入联系人", // 校验提示
        required: false, // 是否必填
        disabled: false, // 是否禁用
        id: "information_titlePic", // 标签id
        size: "default", // 标签大小
        regularCheck: null, // 校验正则
    }, {
        componentType: "NomalInput", // UI类型
        value: "this.state.information.contactsWay", // 值所在位置
        label: "联系方式", // 标签名
        labelCode: "contactsWay", // 标签key
        placeholder: "请输入联系方式", // 空输入框提示
        maxLength: 1, // 最大长度
        message: "请输入联系方式", // 校验提示
        required: false, // 是否必填
        disabled: false, // 是否禁用
        id: "information_titlePic", // 标签id
        size: "default", // 标签大小
        regMessage: '请输入正确的联系方式',
        regularCheck: null, // 校验正则
        // regularCheck: new RegExp('^((0\\d{2,3}-\\d{7,8})|(1[3456789]\\d{9}))$'), // 校验正则
    }],
    [{
        componentType: "TextareInput", // UI类型
        value: "this.state.information.content", // 值所在位置
        label: "任务内容", // 标签名
        labelCode: "content", // 标签key
        placeholder: "请输入任务内容", // 空输入框提示
        maxLength: 1, // 最大长度
        message: "请输入任务内容", // 校验提示
        required: true, // 是否必填
        disabled: false, // 是否禁用
        id: "information_titlePic", // 标签id
        size: "default", // 标签大小
        regularCheck: null, // 校验正则
    }],
    [{
        componentType: "MediaList", // UI类型
        value: "this.state.information.medias", // 值所在位置
        label: "发布媒体", // 标签名
        labelCode: "medias", // 标签key
        placeholder: "请选择发布媒体", // 空输入框提示
        maxLength: 1, // 最大长度
        message: "请选择媒体", // 校验提示
        required: true, // 是否必填
        disabled: false, // 是否禁用
        id: "information_medias", // 标签id
        size: "default", // 标签大小
        regularCheck: null, // 校验正则
    }],
    [{
        componentType: "TaskReporterIds", // UI类型
        value: "this.state.information.taskReporterIds", // 值所在位置（前段存储）
        getValue: "this.state.information.taskReporterObjs", // 值所在位置(后端返回）
        label: "任务记者", // 标签名
        labelCode: "medias", // 标签key
        placeholder: "请添加记者", // 空输入框提示
        maxLength: 1, // 最大长度
        message: "请添加记者", // 校验提示
        regMessage: "请选择记者类型",
        required: true, // 是否必填
        disabled: false, // 是否禁用
        id: "information_taskReporterIds", // 标签id
        size: "default", // 标签大小
        regularCheck: null, // 校验正则
    }],
    [{
        componentType: "UploadInput", // UI类型
        value: "this.state.information.attachments", // 值所在位置
        label: "上传附件", // 标签名
        labelCode: "attachments", // 标签key
        maxLength: 1, // 最大长度
        message: "请上传附件", // 校验提示
        required: false, // 是否必填
        disabled: false, // 是否禁用
        id: "information_attachments", // 标签id
        size: "default", // 标签大小
        regularCheck: null, // 校验正则
    }]


];
export default class AddInterviewTasks extends BaseComponent {
    id = uuid();

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            id: '',
            title:'',
            information: {
                title: '',
                "taskTopicId": "627eacafa371430001c1ae10",
                place: '',
                sponsor: "",
                contacts: "",
                contactsWay: "",
                content: "",
                medias: [],//选择的媒体
                taskReporterIds: [],
                taskReporterObjs:[],
                attachments: []
            }
        };
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    componentWillUnmount() {
    }

    show(id,title) {

        if (id) {
            this.getData(id, (res) => {
                this.setState({information: res, visible: true, id: id,title:title},()=>{

                })
            });
            return false
        }
        this.setState({visible: true, id: '',title:title})
    }

    addTask(data) {
        this.state.information = data;
        this.state.information.medias = [];
        this.state.information.taskReporterIds= [];
        this.state.information.taskReporterObjs = [];
        this.setState({visible: true})

    }

    getData(id, call) {
        let url = '/cm-sites-business/bd/busTask/getById/';
        this.request({
            url: "" + url + id,
            method: "post",
            body: {
                "showRef": [
                    "taskReporterIds",
                    "clueId",
                    "topicSelectionId"
                ]
            },
            contentType: 'json',
            callBack: (data) => {
                call && call(data)
            }
        });
    }

    render() {
        let id = `a-${this.id}-modal`;
        const footerButtons =   <> 
        {this.state.information.status ==='草稿' || this.state.title === '新建' ?
            <Button onClick={() => {
                        this.saveDate('staging')
                    }}>暂存</Button>: 
            <Button onClick={() => {
                        this.setState({visible:false})
                    }}>取消</Button>}
            <Button type="primary" onClick={() => {
                        this.saveDate('add')
                    }}>提交</Button>
        </>
        return (
            <Modal
                title={this.state.title +'任务'}
                visible={this.state.visible}
                footer={footerButtons}
                maskClosable={false}
                width={800}
                onCancel={() => {
                    this.setState({visible: false, modalKey: uuid()})
                }}
            >
                <Scrollbars autoHeight
                            autoHeightMax={600}
                            autoHide
                >
                    <div id={id}>{
                        config && config.length && config.map((item, index) => {
                            return (
                                <div key={index} style={{
                                    display: item && item.length > 1 ? "flex" : '',
                                    justifyContent: item && item.length > 1 ? "space-between" : ''
                                }}>{
                                    item.map((componentItem, _index) => {
                                        return this.renderItem(componentItem, _index, index)
                                    })}
                                </div>

                            )
                        })
                    }</div>
                    <style>{`
                            #${id} .ant-form-item-label{
                                width: ${config.labelWidth || 80}px;
                                vertical-align: top
                            }
                            #${id} .ant-form-item .ant-form-item-control-wrapper .ant-form-item-control{
                                line-height: '';
                            }
                        `}</style>
                </Scrollbars>

            </Modal>
        )
    }

    renderItem = (componentItem, _index, index) => {
        let ItemComponent = null;
        try {
            ItemComponent = require(`../components/btn/${componentItem.componentType}.js`).default;
        } catch (e) {
            console.log(e.toString())
        }
        let value = componentItem.value;
        let getValue = componentItem.getValue || value;
        let itemValue;
        if (getValue.indexOf(',') > -1) {
            try {
                itemValue = [eval(eval(getValue.split(','))[0]), eval(eval(getValue.split(','))[1])];
            } catch (e) {
                console.log(e.toString())
            }
        } else {
            itemValue = eval(getValue);
        }
        let callBack = (val) => {
            this.onInformationChange({code: getValue, val})
        };
        return (
            <ItemComponent
                key={index + "_" + _index}
                {...componentItem}
                // itemValue={this.state.information[componentItem.labelCode]}
                itemValue={itemValue}
                callBack={callBack}
            />
        );
    };

    onInformationChange = ({code, val, setState = false}) => {
        if (code.indexOf(",") > -1) {
            let arr = code.split(",");
            arr.forEach((item, i) => {
                this.evalFun({code: item, val: val[i]});
            })
        } else {
            this.evalFun({code: code, val: val});
        }
        // 备注：只有动态字段需要使用${}包裹
        if (setState) {
            this.setState({});
        }
    };

    evalFun = ({code, val}) => {
        try {
            eval(`${code}=val`);
        } catch (e) {
            console.log(e.toString())
        }
    };

    // 中断错误方法
    errFun = (msg, call) => {
        window.loading.hide();
        if (msg) {
            message.destroy();
            message.warning(msg);
        }
        call && call(false);
    };

    checkForm = (call) => {
        // 1、校验固定字段
        for (let f = 0; f < config.length; f++) {
            let Item = config[f];
            for (let i = 0; i < Item.length; i++) {
                let item = Item[i];
                let val = eval(`${item.value}`);
                let message = item.message;
                let regMessage = item.regMessage;
                // 校验必填
                if (item.required) {
                    if (typeof val === "string") {
                        if (!(val && val.trim() && val.trim().length > 0)) {
                            this.errFun(message, call);
                            return false;
                        }
                    }
                    if (Array.isArray(val)) {
                        if (!(val.length > 0)) {
                            this.errFun(message, call);
                            return false;
                        }
                        // 校验记者类型
                        if(item.componentType === "TaskReporterIds") {
                            if(val.some(reporter=>!(reporter.taskRole && reporter.taskRole.length))) {
                                this.errFun(regMessage,call);
                                return false;
                            }
                        }
                    }
                }
                // 校验正则
                if (val && item.regularCheck) {
                    if (!item.regularCheck.test(val)) {
                        this.errFun((regMessage || message), call);
                        return false;
                    }
                }
            }
        }
        return true
    };

    setValueOfGetValue = (value, getValue) => {
        try {
            this.evalFun({code:value,val:eval(`${getValue}`)})
        } catch (e) {
            console.log(e.toString())
        }
    };

    //确定
    saveDate(data) {
        let {information} = this.state;
        let url = '';
        let {attachments} = information;
        let flag = true;

        if (this.state.id !== '') {
            url = '/cm-sites-business/bd/busTask/update/' + this.state.id;
        } else {
            url = '/cm-sites-business/bd/busTask/add'
        }
        // 将getValue的值赋值给value,注意：这里没有做数组类数据兼容。
        config.forEach(Item=>{
           Item.forEach(item=>{
               if(item.getValue && item.getValue.length>0) {
                   this.setValueOfGetValue(item.value, item.getValue)
               }
           })
        });
        let checkResult = this.checkForm();
        if (!checkResult) {
            return false;
        }
        if (data === 'staging') {
            if( this.state.information.status !=='进行中'){
                this.state.information.status = '草稿';
            }

        } else {
            this.state.information.status = '未领取'
        }
        if (information.replyTime && information.startTime) {
            if(information.replyTime>information.startTime===false){
                message.error("回稿时间不能早于活动时间的起始时间");
                return false;
            }
        }

        if(attachments && attachments.length){
            attachments.forEach((file, index) => {
                if (!file.url) {
                    message.destroy();
                    let name = file.name || file.originFileObj.name;
                    message.error(`${name}尚未上传完成，请等待所有文件上传完成！`);
                    flag = false
                }
            });
        }
        if(flag){
            this.request({
                url: url,
                method: "post",
                body: this.state.information,
                contentType: 'json',
                callBack: (data) => {
                    if (data) {
                        message.success('操作成功');
                        this.props.callBack && this.props.callBack();
                        this.setState({visible: false})
                    }
                }
            });
        }

    }
}
